import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// El backend responde { data, state, message }: un fallo de negocio llega con
// state=false y HTTP 200, así que se convierte en excepción para el toast.
const resultado = (data) => {
  if (data?.state === false) throw new Error(data?.message || 'No fue posible completar la acción');
  return data?.data;
};

export const getPersonalAdministrativo = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/personal-administrativo`, { params });
  return resultado(data) || [];
};

export const crearPersonalAdministrativo = async (payload) => {
  const { data } = await axios.post(`${API_URL}/personal-administrativo`, payload);
  return resultado(data);
};

export const actualizarPersonalAdministrativo = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/personal-administrativo/${id}`, payload);
  return resultado(data);
};

export const eliminarPersonalAdministrativo = async (id) => {
  const { data } = await axios.delete(`${API_URL}/personal-administrativo/${id}`);
  return resultado(data);
};
